var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-select", {
    attrs: {
      value: _vm.searchWord,
      options: _vm.options,
      label: _vm.$t("label.seller"),
      "use-input": "",
      "hide-selected": "",
      "fill-input": ""
    },
    on: { input: _vm.input, filter: _vm.filter }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }